import fileIcon from '@/assets/icons/file-icon.svg'
import folderIcon from '@/assets/icons/folder-icon.svg'
import { FinderItem } from './types'

export function formatBytes(bytes: number | undefined): string {
    if (!bytes || bytes === 0) return '--'
    const k = 1024
    const sizes = ['B', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

export function formatDate(date: string | Date | undefined): string {
    if (!date) return '--'
    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString([], { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}

export function formatFullDate(date: string | Date | undefined): string {
    if (!date) return '--'
    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleDateString([], {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
}

export function getItemIcon(item: FinderItem): string {
    void item
    return item.type === 'folder' ? folderIcon : fileIcon
}

export function truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
}

export function getOwnerName(item: FinderItem): string {
    if (!item.owner) return '--'
    return item.owner.name || item.owner.user?.fullname || item.owner.email || '--'
}
